/**
 * Tries a primary parser (deterministic) and, only when it fails to match a
 * template, falls back to a secondary (the LLM). The LLM never sees a question
 * the templates already handle, and its output still flows through the same
 * grounding + validation — so it broadens coverage without taking the wheel.
 */
import type { ParseContext, ParseResult, SemanticParser } from "./types.ts";
import { ParseError } from "./types.ts";

export class FallbackParser implements SemanticParser {
  readonly name: string;
  private readonly primary: SemanticParser;
  private readonly secondary: SemanticParser;

  constructor(primary: SemanticParser, secondary: SemanticParser) {
    this.primary = primary;
    this.secondary = secondary;
    this.name = `${primary.name}+${secondary.name}`;
  }

  async parse(question: string, ctx?: ParseContext): Promise<ParseResult> {
    try {
      return await this.primary.parse(question, ctx);
    } catch (err) {
      if (err instanceof ParseError) return this.secondary.parse(question, ctx);
      throw err;
    }
  }
}
